<template>
  <b-modal v-model="visible" title="Edycja konta lektora" @ok="onOk" @show="onShow">
    <div class="container">
      <b-row>
        <b-form @submit.prevent="onSubmit" class="col-12">
          <b-form-group class="required" label="Imię">
            <b-form-input
              v-model="firstName"
              type="text"
              autocomplete="off"
              :state="$v.firstName.$error? false : null"
              @input="$v.firstName.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.firstName.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Nazwisko">
            <b-form-input
              v-model="lastName"
              type="text"
              autocomplete="off"
              :state="$v.lastName.$error? false : null"
              @input="$v.lastName.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.lastName.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Nr telefonu">
            <b-form-input
              v-model="phoneNumber"
              type="text"
              autocomplete="off"
              :state="$v.phoneNumber.$error? false : null"
              @input="$v.phoneNumber.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.phoneNumber.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Skype">
            <b-form-input
              v-model="skype"
              type="text"
              autocomplete="off"
              :state="$v.skype.$error? false : null"
              @input="$v.skype.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.skype.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Opis" :disabled="!id">
            <b-form-textarea v-model="description" rows="3" max-rows="6" autocomplete="off" />
          </b-form-group>
        </b-form>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      id: null,
      visible: false,
      firstName: null,
      lastName: null,
      skype: null,
      phoneNumber: null,
      description: null
    };
  },
  props: ["lector"],
  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    skype: {
      required
    },
    phoneNumber: {
      required
    }
  },
  methods: {
    show() {
      this.visible = true;
    },
    onShow() {
      this.$v.$reset();

      if (this.lector) {
        this.id = this.lector.id;
        this.firstName = this.lector.firstName;
        this.lastName = this.lector.lastName;
        this.skype = this.lector.skype;
        this.phoneNumber = this.lector.phoneNumber;
        this.description = this.lector.description;
      } else {
        this.id = null;
        this.firstName = null;
        this.lastName = null;
        this.skype = null;
        this.phoneNumber = null;
        this.description = null;
      }
    },
    onSubmit() {
      this.$v.$touch();

      if (!this.$v.$error) {
        let result = {
          id: this.lector.id,
          firstName: this.firstName,
          lastName: this.lastName,
          skype: this.skype,
          phoneNumber: this.phoneNumber,
          description: this.description
        };

        this.$emit("save", result);
        this.visible = false;
      }
    },
    onOk(e) {
      e.preventDefault();
      this.onSubmit();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

